export default {
      id: "icon-accordion-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons.svg#icon-accordion",
      toString: function () {
        return this.url;
      }
    }